import React, { Component } from 'react';
import moment from 'moment';
import { CURRENCY, FORMAT_NUMBER, SYMBOL } from '../../libs/utils/Const';
import { ApiClient } from "../../libs/apiClient";
const apiClient = ApiClient.getInstance();


class SetDocsToDelivery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            docsByTurn: [],
            linesOfSearchDocs: [],
            chooseDocs: [],
            showSearchedLines: false,
        };
    }

    componentDidMount = () => {
        this.SearchDocsByTurn()
    }

    SearchDocsByTurn = async () => {
        const { enableSpinner, showAlert } = this.props


        enableSpinner(true);
        const responseApi = await apiClient.getDocsByTurn();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }
        await this.setState({
            docsByTurn: responseApi.data ?? []
        })
    }

    AddToSearchLines = (doc) => {
        this.setState((prevState) => {
            const exists = prevState.chooseDocs.some((item) => item.NumAtCard === doc.NumAtCard);

            return {
                chooseDocs: exists
                    ? prevState.chooseDocs.filter((item) => item.NumAtCard !== doc.NumAtCard) // Remove if exists
                    : [...prevState.chooseDocs, doc] // Add if not exists
            };
        });
    };


    SearchLinesByDocs = async (ID = null) => {
        const { enableSpinner, showAlert } = this.props

        if (ID !== null && !this.ValidateToSearchDoc) return;
        if (this.state.chooseDocs.length === 0 && ID === null) {
            showAlert({ type: "info", message: `Selecciona un documento o busca uno por favor`, timeOut: 9000 });
            return;
        }


        const data = {
            docs: this.state.chooseDocs,
            uniqueFolio: ID
        }

        enableSpinner(true);
        const responseApi = await apiClient.getLinesToDelivery(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }
        showAlert({ type: "info", message: `Indica la mercancía que ya le entregaste al cliente por favor`, timeOut: 9000 });

        await this.setState({
            linesOfSearchDocs: responseApi.data ?? [],
            showSearchedLines: true
        })


    }

    SendToRoute = async () => {
        const { enableSpinner, showAlert } = this.props


        const data = {
            docs: this.state.linesOfSearchDocs,
        }

        enableSpinner(true);
        const responseApi = await apiClient.scheduleToRoute(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }
        showAlert({ type: "success", message: `Documento listo para que un administrador lo envié a domicilio` });
        this.props.closeDocsToDelivery();
    }


    ReturnToSearchDocs = () => {
        this.UpdateStateField('showSearchedLines', false)
    }

    ValidateToSearchDoc = () => {
        return true;
    }

    DoSearch = async (data, searchTerm) => {
        const tableReg = document.getElementById(data);
        const searchText = document.getElementById(searchTerm).value.toLowerCase();
        let total = 0;
        // Recorremos todas las filas con contenido de la tabla
        for (let i = 1; i < tableReg.rows.length; i++) {
            // Si el td tiene la clase "noSearch" no se busca en su contenido
            // if (tableReg.rows[i].classList.contains("noSearch")) {
            //     continue;
            // }
            let found = false;
            const cellsOfRow = tableReg.rows[i].getElementsByTagName('td');
            // Recorremos todas las celdas
            for (let j = 0; j < cellsOfRow.length && !found; j++) {
                const compareWith = cellsOfRow[j].innerHTML.toLowerCase();
                // Buscamos el texto en el contenido de la celda
                if (searchText.length == 0 || compareWith.indexOf(searchText) > -1) {
                    found = true;
                    total++;
                }
            }
            if (found) {
                tableReg.rows[i].style.display = '';
            } else {
                // si no ha encontrado ninguna coincidencia, esconde la
                // fila de la tabla
                tableReg.rows[i].style.display = 'none';
            }
        }
    }

    IsInteger(num) {
        if (num % 1 === 0) {
            return true
        } else {
            return false
        }
    }

    ChangeQuantityDelivery = async (index, indexOfLineDoc, item, event) => {
        const { showAlert } = this.props;
        const { linesOfSearchDocs } = this.state;
        let newQuantity = event.nativeEvent.target.value;

        if (Number(newQuantity) > Number(item.Quantity)) {
            newQuantity = Number(item.Quantity);
            linesOfSearchDocs[index].Lines[indexOfLineDoc].FMB_DelivrdQty = newQuantity;
            this.UpdateStateField('linesOfSearchDocs', linesOfSearchDocs);
            showAlert({ type: 'warning', message: 'No puedes devolver mas unidades de las visibles', timeOut: 0 });
            return;
        } else {
            if (Number(newQuantity) <= Number(item.Quantity) && Number(newQuantity) >= 0) {
                linesOfSearchDocs[index].Lines[indexOfLineDoc].FMB_DelivrdQty = newQuantity;
                this.UpdateStateField('linesOfSearchDocs', linesOfSearchDocs);
            }
        }
    }

    ChangeDocPrioridad = async (indexDoc, value) => {
        const { linesOfSearchDocs } = this.state;
        linesOfSearchDocs[indexDoc].U_PRIORIDADVTA = value;
        this.UpdateStateField('linesOfSearchDocs', linesOfSearchDocs);
    }

    UpdateStateField = async (key, value) => {
        await this.setState({
            [key]: value
        })
    }



    render() {
        // const { ShowSavedSalesModal, SavedSalesTools, CounterRol } = this.props;
        const { showSearchedLines } = this.state
        return (
            <>
                <div className="modal fade" id="deliveryDocs" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="savedSalesModalLabel" aria-hidden="true" >
                    <div className="modal-dialog modal-xl modal-dialog" >
                        <div className="modal-content">
                            <div className="modal-header" style={{ background: "#343a40" }}>

                                <div className='col-6 text-center'>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">
                                                <i class="fa fa-barcode" aria-hidden="true" />
                                            </span>
                                        </div>
                                        <input type="text"
                                            class="form-control"
                                            id="recuperarFolio"
                                            placeholder={'Recuperar con folio'}
                                            // value={SavedSalesTools.savedSaleSearchCode}
                                            // onChange={(value) => SavedSalesTools.OnchangeSaleSearchCode(value.target.value)}
                                            onKeyUp={(ev) => { if (ev.key === 'Enter') { } }}
                                        />
                                    </div>

                                </div>
                                <div className='col-3'>

                                </div>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} onClick={this.props.closeDocsToDelivery}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="mt-2">
                                    <section>
                                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                                            <li className="nav-item waves-effect waves-light">
                                                <h5 className="nav-link active" id="general-tab" data-toggle="tab" href="#general" role="tab" aria-controls="general-tab" aria-selected="false">{!showSearchedLines ? 'Docs. del dia' : 'Mercancias'}</h5>
                                            </li>
                                        </ul>
                                        <div className="tab-content" id="myTabContent" style={{ border: "1px solid #dee2e6", borderTop: "none" }}>
                                            {!showSearchedLines ?
                                                <>
                                                    {/* -------------------------------------PENDIENTES--------------------------------------------------------- */}
                                                    <div className="tab-pane fade active show" id="general" role="tabpanel" aria-labelledby="general-tab">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className='scrollTableSaves' style={{ maxHeight: "630px", minHeight: "120px" }}>
                                                                    <table className="table table-striped table-hover" id="saveds">
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="text-center" colSpan={2}>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control "
                                                                                        placeholder="Buscar en guardadas"
                                                                                        id="savedSalesSearch"
                                                                                        onKeyUp={() => this.DoSearch("saveds", "savedSalesSearch")}
                                                                                    />
                                                                                </th>
                                                                                <th className="text-center">Fecha</th>
                                                                                <th className="text-center">Hora</th>
                                                                                <th className="text-left">Cliente</th>
                                                                                <th className="text-center">Monto</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.state.docsByTurn.map((doc, index) => {
                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <td className="text-center">
                                                                                            <input type='checkbox'
                                                                                                className='cursor-pointer ml-3'
                                                                                                checked={this.state.chooseDocs.some((item) => item.NumAtCard === doc.NumAtCard)}
                                                                                                onChange={() => this.AddToSearchLines(doc)}
                                                                                            >
                                                                                            </input>
                                                                                        </td>
                                                                                        <td className="text-center">{doc.NumAtCard}</td>
                                                                                        <td className="text-center">{doc.DocDate ? moment(doc.DocDate).utc().format('YYYY-MM-DD') : ''}</td>
                                                                                        <td className="text-center">{doc?.DocTime !== null ? (doc?.DocTime ?? '').toString().length > 4 ? doc?.DocTime : moment(doc?.DocTime).format('LT') : ''}</td>
                                                                                        <td className="text-left">{doc.CardName ?? ''}</td>
                                                                                        <td className="text-center">{`$ ${FORMAT_NUMBER.new(doc.DocTotal)} ${CURRENCY}`}</td>

                                                                                    </tr>
                                                                                );
                                                                            })
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    {/* -------------------------------------LINEAS DE LOS DOCUMENTOS--------------------------------------------------------- */}
                                                    <div className="tab-pane fade active show" id="general" role="tabpanel" aria-labelledby="general-tab">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className='card scrollTableRefound m-4' style={{ maxHeight: "560px" }}>
                                                                    <table className="table table-striped table-hover">
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="text-center" scope="col">#</th>
                                                                                <th className="text-center" scope="col">
                                                                                    {/* <input
                                                                                        type="checkbox"
                                                                                        style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                                        id="CheckAll"
                                                                                    // onChange={(event) => checkbox.selectAll(event.target.checked)}
                                                                                    /> */}
                                                                                </th>
                                                                                <th className="text-center" scope="col"> Código </th>
                                                                                <th className="col-6 text-center" scope="col"> Nombre</th>
                                                                                <th className=" text-center" scope="col">Cantidad T.</th>
                                                                                <th className="text-center" scope="col">Cantidad E.</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.state.linesOfSearchDocs.map((document, indexDoc) => {
                                                                                return (
                                                                                    <>

                                                                                        <tr className="spacer-row">
                                                                                            <td colSpan="2">
                                                                                                <span className="font-weight-bold">{document?.NumAtCard ?? ''}</span>

                                                                                            </td>
                                                                                            <td colSpan="4">
                                                                                                <div className="input-group">
                                                                                                    {/* <div className="input-group-prepend">
                                                                                                        <span className="input-group-text font-weight-bold">
                                                                                                            Prioridad
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <select
                                                                                                        name="select"
                                                                                                        className="form-control"
                                                                                                        style={{
                                                                                                            color: "#000",
                                                                                                            borderRadius: 4,
                                                                                                            backgroundColor: "transparent",
                                                                                                            height: 40,
                                                                                                        }}
                                                                                                        value={document?.U_PRIORIDADVTA ?? ''}
                                                                                                        onChange={(event) => this.ChangeDocPrioridad(indexDoc,event.target.value)}
                                                                                                    >
                                                                                                        <option value="">Seleccionar</option>
                                                                                                        <option value={1}>Por programar</option>
                                                                                                        <option value={2}>Normal</option>
                                                                                                        <option value={3}>Urgente</option>
                                                                                                    </select> */}
                                                                                                </div>

                                                                                            </td>
                                                                                        </tr>

                                                                                        {document.Lines.map((item, indexLineOfDoc) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <tr>
                                                                                                        <td className="text-center "> <strong>{indexLineOfDoc + 1}</strong> </td>
                                                                                                        <td className="text-center">
                                                                                                            {/* <input
                                                                                                                type="checkbox"
                                                                                                                style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                                                          
                                                                                                            /> */}
                                                                                                        </td>
                                                                                                        <td className="text-center"><strong>{item.ItemCode}</strong> </td>
                                                                                                        <td className="text-center"> {item.Dscription}</td>
                                                                                                        <td className="text-center"> {Number(item.Quantity)}</td>
                                                                                                        <td className="text-center">
                                                                                                            {this.IsInteger(Number(item.Quantity).toFixed(4)) ?
                                                                                                                <strong>{parseInt(item.Quantity)} /
                                                                                                                    <input
                                                                                                                        type="number"
                                                                                                                        min={0}
                                                                                                                        className="text-center input-cantidad"
                                                                                                                        max={parseInt(item.Quantity)}
                                                                                                                        onChange={(event) => { this.ChangeQuantityDelivery(indexDoc, indexLineOfDoc, item, event) }}
                                                                                                                        value={item?.FMB_DelivrdQty ?? 0}
                                                                                                                    />
                                                                                                                </strong>
                                                                                                                :
                                                                                                                <>
                                                                                                                    <strong>{Number(item.Quantity ?? 0).toFixed(4)}{" / "}</strong>
                                                                                                                    <input
                                                                                                                        type="number"
                                                                                                                        className="text-center input-cantidad"
                                                                                                                        value={item?.FMB_DelivrdQty ?? ''}
                                                                                                                        onChange={(event) => { this.ChangeQuantityDelivery(indexDoc, indexLineOfDoc, item, event) }}
                                                                                                                    />
                                                                                                                </>
                                                                                                            }
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </>
                                                                                            )
                                                                                        })
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </>
                                            }


                                        </div>
                                    </section>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.props.closeDocsToDelivery}>Cerrar</button>
                                {!this.state.showSearchedLines ?
                                    <>
                                        <button type="button" className="btn btn-primary" onClick={() => this.SearchLinesByDocs()}>Entrega parcial</button>
                                        {/* <button type="button" className="btn btn-success" onClick={() => this.SendToRoute(1)}>Enviar todo</button> */}
                                    </>
                                    :
                                    <>
                                        <button type="button" className="btn btn-primary" onClick={() => this.ReturnToSearchDocs()}>Regresar</button>
                                        <button type="button" className="btn btn-success" onClick={() => this.SendToRoute(2)}>Mandar a ruta</button>
                                    </>

                                }


                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

export default SetDocsToDelivery;